import { Link } from "react-router-dom";
import { SideBar } from "../../components/SideBar/SideBar";
import useAuthService from "../../auth/AuthService";
import { ResetPassword } from "../../services/external.api.service";
import { useEffect, useState } from "react";
import { handleMessage } from "../../utils/handleMessagePopup";

interface SecurityAndPrivacyProps {
  userRole: string;
}

const SecurityAndPrivacy: React.FC<SecurityAndPrivacyProps> = ({ userRole }) => {
  const { isAuthenticated, getToken, getLinkedIdentities } = useAuthService();
  const [state, setState] = useState({
    isLoading: false,
    hasUsernamePassword: false
  });

  useEffect(() => {
    const fetchData = async () => {
      const res = await getLinkedIdentities();
      const hasUsernamePassword = res.some(
        (identity: { connection: string }) => identity.connection === "Username-Password-Authentication"
      );
      setState((prev) => ({ ...prev, hasUsernamePassword: hasUsernamePassword }))
    }

    fetchData()
  }, [getLinkedIdentities])

  const handleToggle = (key: keyof typeof state, value: boolean) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleResePassword = async () => {
    try {
      if (isAuthenticated) {
        handleToggle("isLoading", true)
        const res = await ResetPassword(getToken)
        if (res.data === "success" && res.error === null) {
          handleMessage("Check email to reset")
          handleToggle("isLoading", false)
        }
      }
    } catch {
      handleToggle("isLoading", false)
    }
  }
  return (
    <>{state.isLoading ? (
      <div className="loader">
        <div className="spinner"></div>
      </div>
    ) : (
      <></>
    )}
      <div className="container profile-page ps-2">
        <div className="edit-profile-header py-4">Settings</div>
        <div className="security-details">
          <div className="side-bar">
            <SideBar ActiveItem="securityPrivacy" userRole={userRole} />
          </div>
          <div className="page-content">
            <div className="profile-content security-content">
              <div className="heading">Security & Privacy</div>
              <div className="row">
                <div className="col-lg-5 col-10">
                  {state.hasUsernamePassword && <div className="py-3">
                    <div className="sub-heading">Security</div>
                    <div onClick={handleResePassword} className="cursor-pointer detail-left d-flex p-0 purple-color content">
                      <div>Reset Password</div>
                      <i className="fa-solid fa-angle-right mt-1 ms-2"></i>
                    </div>
                  </div>
                  }
                  <div>
                    <div className="sub-heading">Privacy</div>
                    <div className="detail-left d-flex p-0 purple-color content align-items-center">
                      <Link
                        to="/privacy"
                        className="text-decoration-none d-flex align-items-center"
                      >
                        <div>Privacy Notice</div>
                        <i className="fa-solid fa-angle-right ms-2"></i>
                      </Link>
                    </div>

                    {/* <div className="detail-left d-flex p-0 purple-color content">
                    <div>Hide Assets Owned</div>
                    <i className="fa-solid fa-angle-right mt-1 ms-2"></i>
                  </div>
                  <div className="detail-left d-flex p-0 purple-color content">
                    <div>Ads Preferences</div>
                    <i className="fa-solid fa-angle-right mt-1 ms-2"></i>
                  </div>
                  <div className="detail-left d-flex p-0 purple-color content">
                    <div>Data Sharing with Partners</div>
                    <i className="fa-solid fa-angle-right mt-1 ms-2"></i>
                  </div> */}
                  </div>
                  {/* <div className="py-3">
                  <div className="sub-heading">Learn More About Fan1 Privacy Policy</div>
                  <div className="detail-left d-flex p-0 purple-color content">
                    <div>Privacy Policy</div>
                    <i className="fa-solid fa-angle-right mt-1 ms-2"></i>
                  </div>
                </div> */}
                </div>
                {/* <div className="col-lg-5 col-2">
                                <div className="padding-y"></div>
                                <div className="padding-y" ><i className="fa-solid fa-angle-right"></i></div>
                                <div className="padding-y"><i className="fa-solid fa-angle-right"></i></div>
                                <div className="padding-y"></div>
                                <div className="padding-y"><i className="fa-solid fa-angle-right"></i></div>
                                <div className="padding-y"><i className="fa-solid fa-angle-right"></i></div>
                                <div className="padding-y"><i className="fa-solid fa-angle-right"></i></div>
                                <div className="padding-y"> </div>
                                <div className="padding-y"><i className="fa-solid fa-angle-right"></i></div>
                            </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SecurityAndPrivacy;
